import {
	DestroyRef,
	Directive,
	ElementRef,
	inject,
} from '@angular/core';
import { DrawerService } from './drawer.service';

@Directive({
	selector: 'skl-drawer-outlet, [sklDrawerOutlet]',
	exportAs: 'sklDrawerOutlet',
})
export class DrawerOutletDirective {
	readonly #drawerService = inject(DrawerService);
	readonly #elementRef = inject(ElementRef<HTMLElement>);
	readonly #destroyRef = inject(DestroyRef);

	constructor() {
		this.#destroyRef.onDestroy(() => this.#drawerService.unregisterOutlet(this.#elementRef.nativeElement));
		this.#drawerService.registerOutlet(this.#elementRef.nativeElement);
	}
}
